import { Injectable, Type } from '@angular/core';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ScreenSizeService } from './utils/screenSize.service';
import { OffcanvasHistoryService } from './offcanvas-history.service';

@Injectable({
    providedIn: 'root',
})

export class ModalOffcanvasService {
    constructor(
        private modalService: NgbModal,
        private offcanvasHistory: OffcanvasHistoryService,
        private screenSize: ScreenSizeService
    ) { }

    async openComponent<T>(
        component: Type<T>,
        componentInputs: Partial<T> = {},
        options: any = {},
        forceOffcanvas: boolean = false
    ): Promise<any> {

        if (this.screenSize.isDesktop && !forceOffcanvas) {

            const modalRef = this.modalService.open(component, {
                centered: false,
                size: 'lg',
                scrollable: true,
                backdrop: options.backdrop ?? true,
                ...options,
            });

            Object.assign(modalRef.componentInstance, componentInputs);
            return modalRef.result;
        } else {

            const offcanvasRef = this.offcanvasHistory.open(component, {
                position: 'bottom',
                scroll: false,
                backdrop: options.backdrop ?? true,
                panelClass: 'app-offcanvas-taller',
                ...options,
            });

            Object.assign(offcanvasRef.componentInstance, componentInputs);
            return offcanvasRef.result;
        }
    }
}